<div class="dialog-content-wrapper">
  <mat-toolbar mat-dialog-title class="mat-accent m-0">
    <div fxFlex fxLayout="row" fxLayoutAlign="space-between center">
      <span class="title dialog-title">Payment Method</span>
      <button (click)="onNoClick()" aria-label="Close dialog">
        <mat-icon class="closebtn">close</mat-icon>
      </button>
    </div>
  </mat-toolbar>
  <mat-progress-bar *ngIf="loading" mode="query" class="my-color" mode="query" value="value"
    [bufferValue]="bufferValue"></mat-progress-bar>
  <div class="content">
    <mat-form-field>
      <mat-label>Select Mode</mat-label>
      <mat-select [(ngModel)]="selectMode">
        <!-- <mat-option value="bankTransfer">Bank Transfer</mat-option> -->
        <mat-option id="mode_{{pmode.paymentKey}}" *ngFor="let pmode of paymentModes" [value]="pmode.paymentKey"> {{pmode.paymentVal}}</mat-option>
        
      </mat-select>
    </mat-form-field>
    <button [class.loading]="formActionLoading" mat-raised-button class="pull-right space actionButton" color="accent"
      (click)="submitMode()" [disabled]="formActionLoading" style="text-transform: uppercase;">
      <div class="spinner"></div>
      <span class="label">Pay ${{formFee/100}}</span>
    </button>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/main/content/common/dailog/mode-of-payments-dialog/mode-of-payments-dialog.component.html